const VisPage404 = () => import('@/views/vis-page404');

export default [
  {
    path: '/page404',
    name: 'page404',
    component: VisPage404
  }
]
